import axios from 'axios';

const create = (idCotacao, idResposta, data) => axios.post(`/cotacoes-fretes/${idCotacao}/respostas/${idResposta}/contratar`, data);

const getConstratacoes = params => axios.get('/contratacoes-fretes', {
  params,
});

const getContratacao = id => axios.get(`/contratacoes-fretes/${id}`);
const cancelar = (id, data) => axios.put(`/contratacoes-fretes/${id}/cancelar`, data);

const locaisFavoritos = params => axios.get('/locais-fretes-favoritos', { params });

const notificarNegociacao = id => axios.post(`/notificacoes/contrato_frete/${id}`, {});
const updateIdentifier = (id, cotacao) => axios.put(`/contratacoes-fretes/${id}/identifier`, cotacao);

export default {
  create,
  getConstratacoes,
  getContratacao,
  cancelar,
  locaisFavoritos,
  notificarNegociacao,
  updateIdentifier,
};
